import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';

export interface TopLinkItem {
  href: string;
  text: string;
  analyticsText: string;
  animation: string;
}

interface FooterTopLinksProps {
  links: TopLinkItem[];
}

export const FooterTopLinks: React.FC<FooterTopLinksProps> = ({ links }) => {
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();

  return (
    <ul className={'mf-footer__top-links'}>
      {links.map((link, index) => (
        <li key={index}>
          <a
            className={`mf-link mf-link--site-montefiore mf-link--primary mf-link--base mf-link--direction-backwards mf-link--animation-${link.animation}`}
            href={link.href}
            data-analytics-click-text={link.analyticsText}
            data-analytics-link-type={'link'}
            onClick={() => {
              analytics.navigationClickEvent({
                navigationType: 'footer',
                clickText: link.analyticsText,
                linkType: 'link',
              });
            }}
          >
            <span className={'mf-link__text'}>
              <span className={'mf-link__text__inner'}>{t(link.text)}</span>
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
};
